export function contains_heb(str) {
  const arabic = /[\u0600-\u06FF]/;
  const hebrew = /[\u0590-\u05FF]/;
  return arabic.test(str) || hebrew.test(str) ? "rtl" : "ltr";
}
